export const noHeaderCss = theme => ({
  main: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(6))]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  main600: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(6))]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  main800: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(6))]: {
      width: 800,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: "50%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
  },
  paperFixedTopMargin: {
    marginTop: "8em",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    marginTop: theme.spacing(3)
  },
  textCentered: {
    textAlign: "center"
  },
  connectionDetails: {
    marginTop: theme.spacing(3)
  },
  textRight: {
    textAlign: "right"
  },
  iconSize: {
    width: 65,
    height: 65
  },
  paperHeader: {
    textAlign: "center",
    marginBottom: theme.spacing(3)
  },
  paperHeaderLogoContainer: {
    marginBottom: theme.spacing(2)
  },
  paperHeaderLogo: {
    height: "7em"
  },
  skipConnectors: {
    textAlign: "center",
    marginTop: theme.spacing(3)
  },
  errorAlert: {
    padding: `${theme.spacing(2)}px`,
    backgroundColor: "#d32f2f",
    color: "#fff"
  },
  successAlert: {
    padding: `${theme.spacing(2)}px`,
    backgroundColor: "#43a047",
    color: "#fff"
  },
  pSize: {
    fontSize: "14px"
  },
  flexContainer: {
    display: "flex",
    flexDirection: "column"
  },
  flexContentBottom: {
    display: "flex",
    flex: "1 0 auto",
    alignItems: "flex-end"
  },
  gswCTA: {
    marginTop: theme.spacing(4),
    textAlign: "center"
  },
  gswAppImage: {
    width: 200,
    marginTop: -theme.spacing(1)
  },
  gswGridItem: {
    marginLeft: "auto",
    marginRight: "auto"
  },
  gswIconSize: {
    height: 150
  },
  searchConnectorsInput: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(3)
  },
  signupCard: {
    textAlign: "center",
    position: "relative",
    cursor: "pointer",
    "&>button":{
      padding: 10, 
      borderTop: "3px solid #fff",
    },
    "&>button:hover":{
      borderTop: `3px solid ${theme.palette.secondary.main}`,
      background: "#fff"
    }
  },
  mainHolder: {
    padding: 20, 
    display: "flex", 
    alignItems: "flex-start", 
    justifyContent: "center", 
    minHeight: "100vh", 
    paddingTop: 230
  },
  formHolder: {
    borderTop: "4px solid orange", 
    padding: "40px 50px", 
    textAlign: "center", 
    position:"relative", 
    boxShadow:"0 5px 25px -20px #091656"
  },
  stepperHolder: {
    background: "linear-gradient(45deg, rgb(1 61 112), rgb(81 139 221))",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: 350,
    display: "flex",
    paddingTop: 100, 
    justifyContent: "center"
  },
  customStepperStyle: {
    background:"transparent",
     width: 900
  },
  connectionIndicator: {
    position:"absolute",
    top: 8, 
    zIndex: 10, 
    right: 5
  },
  cardContent: {
    height: "35px", 
    padding: 0, 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center" 
  },
  cardMedia: {
    height: "80px", 
    backgroundRepeat: "no-repeat", 
    backgroundSize: "contain",
    marginBottom: "10px"
  },
  installCard: {
    width: 150, 
    height: 60, 
    padding: 10, 
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderTop: `3px solid #fff`, 
    "&:hover":{
      borderTop: `3px solid orange`
    }
  }
});
